<template>
  <div class="contact-content" v-if="contact_info || contact">
    <div v-if="contact_info">{{ contact_info }}</div>
    <img :src="contact_value" alt="" v-if="contact_value" @click="showPic" />
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: ["contact_info", "contact", "contact_value"],
  data() {
    return {};
  },
  methods: {
    showPic() {
      ImagePreview([this.contact_value])
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.contact-content {
  background: #fff;
  padding: 0 rem(30) rem(20);
  color: #262626;
  img {
    width: 100%;
    height: rem(300);
    object-fit: contain;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/contact.vue